import type { ProgramacionAcademicaPageModel } from '@/interfaces/model';
import type { ProgramacionAcademicaPage } from '@/interfaces/strapi';
import { mapImage } from '@/helpers/strapi-assets-helpers';

export const programacionAcademicaMapper = (api: ProgramacionAcademicaPageModel): ProgramacionAcademicaPage => ({
	image: mapImage(api.image),
});
